export interface IdentificationByPassportRequest {
	firstName: string,
	lastName: string,
	patronymic: string,
	dateOfBirth: string,
	citizenship: string,
	taxNumber: string,
	identificationDocument: {
		number: string,
		documentType: string,
		issuer: string,
		issuerCode: string,
		issueDate: string
	}
}

export interface PassportFormData {
	firstName: string,
	lastName: string,
	patronymic: string,
	dateOfBirth: string,
  taxNumber: string,
	passportNumber: string,
	passportDate: string,
	passportIssuer: string,
	passportIssuerCode: string,
}

export enum EUserIdentificationLevel {
	Simple = "Simple",
	Anonymous = "Anonymous",
}